import { useNotificationStore, type ToastVariant } from '@/stores/notification'

/**
 * Toast facade — SA5 spec API.
 *
 *   const toast = useToast()
 *   toast.success('保存成功')                           // title only
 *   toast.error('保存失败', '请稍后重试')                 // title + description
 *   toast.warning('警告', '磁盘空间不足', { duration: 0 })
 */
export interface ToastOptions {
  /** Auto-dismiss delay (ms). 0 disables auto-dismiss. Default 3500. */
  duration?: number
}

export interface ToastApi {
  success: (title: string, description?: string, opts?: ToastOptions) => string
  error: (title: string, description?: string, opts?: ToastOptions) => string
  warning: (title: string, description?: string, opts?: ToastOptions) => string
  info: (title: string, description?: string, opts?: ToastOptions) => string
  dismiss: (id: string) => void
  clear: () => void
  variants: ToastVariant[]
}

export function useToast(): ToastApi {
  const store = useNotificationStore()
  const map: Record<ToastVariant, (title: string, description?: string, opts?: ToastOptions) => string> = {
    success: (t, d, o) => store.success(t, d, o?.duration),
    error:   (t, d, o) => store.error(t, d, o?.duration),
    warning: (t, d, o) => store.warning(t, d, o?.duration),
    info:    (t, d, o) => store.info(t, d, o?.duration),
  }
  return {
    success: map.success,
    error: map.error,
    warning: map.warning,
    info: map.info,
    dismiss: (id: string) => store.dismiss(id),
    clear: () => store.clear(),
    variants: ['success', 'error', 'warning', 'info'],
  }
}
